export const useOfflineImg = () => {
  const offlineImg = new Image()
  offlineImg.src = require('@bd/assets/images/no-connection.svg')
  return offlineImg
}
